angular
  .module("app.containers")

  .component("accordionGroup", {
    transclude: true,
    bindings: {
      //Shown process title is a convetion: propMap[processName + '_' + processIndex] 
      title: "@",
      id: "@",
      containerClass: "@"
    },
    templateUrl: "ng/containers/accordionGroup/accordionGroup.view.html",
    controller: AccordionGroupController,
    controllerAs: "accordionGroupCtrl"
  });

function AccordionGroupController() {
  var self = this;

  self.$onInit = function () {


  }
}
